module.exports = __webpack_public_path__ + "static/img/c35.9d73d5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c35.jpg
// module id = 276
// module chunks = 0 1 2 3 4 5 6 7 8 9